const UNIT_RANGES: [Intl.RelativeTimeFormatUnit, number][] = [
  ['day', 60 * 60 * 24],
  ['hour', 60 * 60],
  ['minute', 60],
  ['second', 1],
];

export const getTimeSinceLastUpdated = (
  lastUpdatedDate?: string,
): [number, Intl.RelativeTimeFormatUnit] => {
  if (!lastUpdatedDate) return [0, 'second'];

  const secondsElapsed =
    (new Date(lastUpdatedDate).getTime() - Date.now()) / 1000;
  const absoluteSeconds = Math.abs(secondsElapsed);

  const [unit, threshold] = UNIT_RANGES.find(
    ([, t]) => absoluteSeconds >= t,
  ) ?? ['second', 1];

  return [Math.round(secondsElapsed / threshold), unit];
};
